module.exports = __webpack_public_path__ + "static/media/inova_page-01.d9dce1d0.jpg";